import React from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorState,
} from '@udecode/plate';
import { ELEMENT_OL, getListItemEntry, toggleList } from '@udecode/plate-list';

import { BlockToolbarButton } from './BlockToolbarButton';

export const ListToolbarButton = ({
  id,
  type = ELEMENT_OL,
  ...props
}) => {
  const editor = usePlateEditorState(useEventPlateId(id));

  const res = !!editor?.selection && getListItemEntry(editor);

  return (
    <BlockToolbarButton
      active={!!res && res.list[0].type === type}
      type={type}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        toggleList(editor, { type });
        focusEditor(editor);
      }}
      {...props}
    />
  );
};